<script setup>

import {storeToRefs} from "pinia";
import {useOrdersStore} from "@/stores/order.store";
import {watch} from "vue";
import {useRoute} from "vue-router/dist/vue-router";
import {computed} from 'vue';
import {useRouter} from "vue-router";

const route = useRoute();
const router = useRouter()

const orderStore = useOrdersStore();
const {orders} = storeToRefs(orderStore);

watch(() => route.params.status, async (newStatus) => {
    await orderStore.fetchAll(newStatus);
}, {immediate: true});

const all = computed(() => {
    return route.params.status === 'all' ? 'shopping-cart' : 'shopping-cart-o';
});
const pending = computed(() => {
    return route.params.status === 'pending' ? 'cart' : 'cart-o';
});
const completed = computed(() => {
    return route.params.status === 'completed' ? 'cart-circle' : 'cart-circle-o';
});
const expired = computed(() => {
    return route.params.status === 'expired' ? 'underway' : 'underway-o';
});
</script>

<template>
    <van-space direction="vertical" fill>
        <van-grid :column-num="4">
            <van-grid-item :icon="all" text="All" clickable to="/order/list/all"/>
            <van-grid-item :icon="pending" text="Pending" clickable to="/order/list/pending"/>
            <van-grid-item :icon="completed" text="Completed" clickable to="/order/list/completed"/>
            <van-grid-item :icon="expired" text="Expired" clickable to="/order/list/expired"/>
        </van-grid>


        <template v-if="orders.length > 0">
            <van-cell-group inset v-for="order in orders" :key="order.id" @click="router.push('/order/' + order.id)">
                <van-card
                    v-for="product in order.products"
                    :key="product.id"
                    :num="1"
                    :price="order.total_amount"
                    currency="$"
                    :title="product.name"
                    :thumb="product.thumbnail_file_absolute_path"
                />
                <van-cell title="Order #" :value="order.id"/>
                <van-cell title="Status" :value="order.status"/>
                <van-cell title="Date" :value="order.created_at_formatted"/>
            </van-cell-group>
        </template>
        <div v-else>
            <van-empty description="You don't have any orders"/>
        </div>

    </van-space>
</template>
<style scoped>
.van-card:after {
    position: absolute;
    box-sizing: border-box;
    content: " ";
    pointer-events: none;
    right: var(--van-padding-md);
    bottom: 0;
    left: var(--van-padding-md);
    border-bottom: 1px solid var(--van-cell-border-color);
    transform: scaleY(.5);
}

.van-cell {
    background: var(--van-card-background);
}
</style>
